import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import preparationProfilesStore from '../../store/preparationProfilesStore';
import { PreparationPreOrderSettings } from '../../components/PreparationPreOrderSettings/PreparationPreOrderSettings';
import { PreparationProfileDeliverySettings } from '../../components/PreparationProfileDeliverySettings/PreparationProfileDeliverySettings';
import { PreparationProfilePickupSettings } from '../../components/PreparationProfilePickupSettings/PreparationProfilePickupSettings';
import { PreparationSettingMainSkeletons } from '../../components/PreparationSettingMainSkeletons/PreparationSettingMainSkeletons';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { localeStore } from '~/mobx/localesStore';
import { BUTTON_TITLE } from '~/constants/main';
import './style.scss';

export const PreparationSettingMain: FC = observer((): ReactElement => {
  return (
    <ScrollableBlock showScrollbar className="preparation-setting-main ml-4" scrollClassName="gap-40">
      {preparationProfilesStore.isLoading && !preparationProfilesStore.selectedProfile ? (
        <PreparationSettingMainSkeletons />
      ) : (
        <>
          <div className="d-flex flex-column gap-30">
            <PreparationProfileDeliverySettings />
            <PreparationProfilePickupSettings />
            <PreparationPreOrderSettings />
          </div>

          <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={preparationProfilesStore.submit} />
        </>
      )}
    </ScrollableBlock>
  );
});
